// The one merged grant map this portal evaluates — extracted from main.tsx so
// SessionProvider (affordance gates) and nav.ts (the sidebar) read the SAME
// matrix; two copies could drift into a sidebar offering what the gates hide.
//
// Key-wise union, never a spread. The OPAC member surface lives on the LIB
// grants (the patron role holds lib:opac); the payments surface lives on the
// FIN grants (member roles hold fin:pay); useCan is UI sugar, the API stays
// the only authority.
import { mergeGrants, ROLE_GRANTS } from "@erp/auth-kit/rbac";
import { FIN_GRANTS } from "@erp/module-fin/schemas";
import { LIB_GRANTS } from "@erp/module-lib/schemas";

export const GRANTS = mergeGrants(ROLE_GRANTS, LIB_GRANTS, FIN_GRANTS);
